import { FormDateInput } from 'components/form-fields';
import { useValidation } from 'hooks/useValidation';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { Fragment, useEffect } from 'react';
import classNames from 'classnames';

export function OcrDateLayout(props) {
    const [_, errors, validate] = useValidation();

    useEffect(() => {
        validateLayout();
    }, [props.layout.answer]);

    function validateLayout() {
        const required = props.layout.requiredAnswerCount > 0;
        const rules = [{ fieldName: 'answer', required: required }];
        validate(rules, props.layout);
    }

    function onValueChange(value) {
        const clonedLayout = { ...props.layout };

        clonedLayout.answer = value ? moment(value).format("YYYY-MM-DD") : null;

        props.onChange(clonedLayout);
    }

    return <Fragment>
        <div className={classNames("form-field", { "hide-in-print": !props.readonly, "hidden": props.readonly })}>
            <FormDateInput
        loading={props.loading}
        onChange={onValueChange}
        value={props.layout.answer ? moment(props.layout.answer).toString() : null}
        headingText={props.layout.secondaryLayoutTitle}
        disabled={props.disabled}
        dangerHelperText={errors.answer}
            />
        </div>
        <p className={classNames({ "show-in-print": !props.readonly, "visible": props.readonly, "bp3-skeleton": props.loading })}>{moment(props.layout.answer).format('DD/MM/YYYY')}</p>
    </Fragment>;
}

OcrDateLayout.propTypes = {
    loading: PropTypes.bool,
    layout: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    readonly: PropTypes.bool
};

OcrDateLayout.defaultProps = {
    loading: false,
    disabled: false,
    readonly: false
};
